/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Footer_CompanyInputs */

const en_platform_footer_company = /** @type {(inputs: Platform_Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company`)
};

const pl_platform_footer_company = /** @type {(inputs: Platform_Footer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firma`)
};

/**
* | output |
* | --- |
* | "Company" |
*
* @param {Platform_Footer_CompanyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_footer_company = /** @type {((inputs?: Platform_Footer_CompanyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Footer_CompanyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_footer_company(inputs)
	return en_platform_footer_company(inputs)
});